import React from 'react';
import Button from '@amzn/meridian/button';

export interface AddLineButtonProps {
  onAdd: () => void;
}

const AddLineButton: React.FC<AddLineButtonProps> = ({ onAdd }) => {
  return (
    <Button type="primary" onClick={onAdd}>
      + Add new line
    </Button>
  );
};

export default AddLineButton;
